import * as React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box } from "@mui/material";
import { useState } from "react";
import { MainInput, main_button } from "./Styles";
import { useTranslation } from 'react-i18next';

const ReasonModal = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  title,
  message
}) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const modalTitle = title || t('modals.rejectionReason');
  const modalMessage = message || t('modals.provideReason');

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason);
      setReason("");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && reason.trim()) {
      handleConfirm();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "var(--appBg)",
          color: "var(--secColor4)"
        }
      }}
    >
      <DialogTitle sx={{ backgroundColor: "var(--appBg)", color: "var(--secColor4)" }}>
        <Typography variant="h6" sx={{ color: "var(--secColor4)" }}>
          {modalTitle}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "var(--appBg)", color: "var(--secColor4)" }}>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" sx={{ color: "var(--secColor4)", mb: 2 }}>
            {modalMessage}
          </Typography>
          <MainInput
            margin="normal"
            fullWidth
            label={t('common.reason')}
            multiline
            minRows={3}
            required
            value={reason}
            onChange={({ target }) => setReason(target.value)}
            onKeyPress={handleKeyPress}
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1, backgroundColor: "var(--appBg)" }}>
        <Button
          onClick={handleClose}
          sx={{ color: "var(--secColor4)" }}
          disabled={isLoading}
        >
          {t('common.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          sx={{ ...main_button }}
          disabled={!reason.trim() || isLoading}
        >
          {isLoading ? t('common.submitting') : t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReasonModal;


